// extracted by mini-css-extract-plugin
export default {"container":"footer_container__lq+Gs","leftBox":"footer_leftBox__puTH9","rightBox":"footer_rightBox__tJr4J","middleBox":"footer_middleBox__OrTBm"};